import { useMemo } from 'react'

import { UseTranslationOptions } from 'react-i18next'

const useLanguageForSave = (i18n: UseTranslationOptions['i18n']) => {
  const lang = useMemo(() => {
    if (i18n.language === 'pt-BR') {
      return 'pt-BR'
    }
    const [mainLangCode] = i18n.language.split('-')
    return mainLangCode || 'en'
  }, [i18n.language])

  return lang
}

export default useLanguageForSave
